<template>
  <div class="section_title">
      <h2 class="title ">{{$t(page_title)}}</h2>
      <div class="title_link">
        <div v-if="show_return_account">
          <span class="return-account" >
            <a style="" :href="'/account'">{{$t('account.return_to_account')}}</a>
          </span>
          <span v-if="!isphone">
            /
          </span>
        </div>
        <form id="logout-form" method="POST" action="/logout">
          <input type="hidden" name="_token" :value="token" />
          <button type="submit" class="text-uppercase" href>{{$t('account.log_out')}}</button>
        </form>
      </div>
  </div>
</template>

<script>
export default {
  props:['page_title','show_return_account'],
  data(){
    return{
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      isphone: this.$(window).width() <= 575
    }
  },
  mounted(){
    console.log(this.page_title,"top lag");
  }
}
</script>

<style scoped lang='scss'>
.section_title {
  //margin: 0 auto 18px;
  border-bottom: 1px solid #cccccc;
  display: flex;
  align-items: center;
  padding: 20px 0;
  justify-content: space-between;
  .title{
    height: 32px;
    font-size: 42px;
    font-family: Roboto;
    font-weight: bold;
    color: #222A40;
    line-height: 42px;
  }
  div{
    display: flex;
    button,span {
      height: 16px;
      font-size: 16px;
      font-family: Roboto;
      font-weight: 500;
      text-decoration: none;
      color: #222940;
      line-height: 42px;
    }
    button,.return-account {
      text-decoration: underline;
    }
  }
}


@media screen and (max-width: 768px){
  .section_title{
    flex-direction: column;
    .title{
      font-size: 18px !important;
      line-height: normal !important;
      height: auto !important;
    }
    .title_link{
      margin-top: 25px;
      flex-direction: row;
      justify-content: flex-start;
      width: 100%;
      .return-account{
        margin-right: 30px;
      }
      button,span {
        height: auto !important;
        font-size: 13px !important;
        line-height: normal !important;
      }
    }
  }
}
</style>